module.exports = __webpack_public_path__ + "static/media/employee-profile-icon.2909a9bb.svg";